import { useState } from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarTrigger,
  useSidebar,
} from "../components/Dashboardv2/ui/sidebar";
import { cn } from "../components/Dashboardv2/ui/utils";
import { CurrentProgressTab } from "../components/Dashboardv2/CurrentProgressTab.jsx";
import { DemographicsTab } from "../components/Dashboardv2/DemographicsTab.jsx";
import { SurveyTab } from "../components/Dashboardv2/SurveyTab.jsx";
import { PlanDetailsTab } from "../components/Dashboardv2/PlanDetailsTab.jsx";
import { TimelineTab } from "../components/Dashboardv2/TimelineTab.jsx";
import { ResourcesTab } from "../components/Dashboardv2/ResourcesTab.jsx";
import { 
  BarChart3, 
  Users, 
  FileText, 
  MapPin,
  Calendar, 
  FolderOpen,
  Trees 
} from "lucide-react";

const tabs = [
  { id: "progress", label: "Current Progress", icon: BarChart3, component: CurrentProgressTab },
  { id: "plan-details", label: "Plan Details", icon: MapPin, component: PlanDetailsTab },
  { id: "demographics", label: "Demographics", icon: Users, component: DemographicsTab },
  { id: "survey", label: "Community Input", icon: FileText, component: SurveyTab },
  { id: "timeline", label: "Timeline", icon: Calendar, component: TimelineTab },
  { id: "resources", label: "Resources", icon: FolderOpen, component: ResourcesTab },
];

function Dashboardv2Content() {
  const { setOpenMobile, isMobile } = useSidebar();
  const [activeTab, setActiveTab] = useState("progress");
  
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || CurrentProgressTab;

  return (
    <div className="flex h-full w-full container-width">
      <Sidebar className="w-64 bg-white border-r">
        <SidebarContent>
          <SidebarGroup>
            <SidebarGroupLabel className="flex items-center gap-2 px-2 py-2">
              <Trees className="h-5 w-5" />
              Park Master Plan
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  const isTabActive = activeTab === tab.id;
                  return (
                    <SidebarMenuItem key={tab.id}>
                      <SidebarMenuButton
                        onClick={() => {
                          setActiveTab(tab.id);
                          if (isMobile) {
                            setOpenMobile(false);
                          }
                          // Scroll to top of page smoothly
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        isActive={isTabActive}
                        className={cn(
                          "w-full flex items-center gap-3 px-3 py-2 transition-all",
                          isTabActive 
                            ? "bg-[#D4AF37] text-white font-semibold hover:bg-[#C4A030]" 
                            : "text-gray-700 hover:bg-gray-100"
                        )}
                      >
                        <Icon className="h-4 w-4" />
                        {tab.label}
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  );
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>
      </Sidebar>

      <main className="flex-1 p-6 bg-muted/30 overflow-y-auto relative">
        <div className="md:hidden fixed top-20 left-4 z-50">
          <SidebarTrigger />
        </div>
        <div className="md:hidden mb-4"></div>
        <ActiveComponent />
      </main>
    </div>
  );
}

export default function Dashboardv2() {
  return (
    <SidebarProvider>
      <Dashboardv2Content />
    </SidebarProvider>
  );
}